import React from 'react';
import { BackButton } from 'ui/base/button/back_button';
import { PublicPage } from 'ui/base/page/public_page/public_page';
import { ActiveButton } from 'ui/public/button';
import { Theme, ThemedStyles, useStyles } from 'ui/base/theme';
import baseStyles from './password_reset_confirmation.module.css';
import ConfirmationResetMessages from './password_reset_confirmation_messages';
import { Link } from 'ui/base/link';
import { BasePath } from 'services/base/page_path';
import { useLocation } from 'react-router-dom';
import * as History from 'history';

type PasswordResetConfirmationStyles = {
  title: string;
  body: string;
  bodyItem: string;
  buttonContainer: string;
};

const themedStyles: ThemedStyles<PasswordResetConfirmationStyles> = {
  [Theme.DAYLIGHT]: {
    title: baseStyles.daylightTitle,
    body: baseStyles.daylightBody,
    bodyItem: baseStyles.bodyItem,
    buttonContainer: baseStyles.buttonContainer,
  },
  [Theme.MIDNIGHT]: {
    title: baseStyles.midnightTitle,
    body: baseStyles.midnightBody,
    bodyItem: baseStyles.bodyItem,
    buttonContainer: baseStyles.buttonContainer,
  },
};

function parseQueryString(location: History.Location) {
  const qs = location.search.substring(1).split('&');
  const result: Record<string, string> = {};
  for (const pair of qs) {
    const [key, value] = pair.split('=');
    result[decodeURIComponent(key)] = decodeURIComponent(value);
  }
  return result;
}

export const PasswordResetConfirmation = () => {
  const location = useLocation();
  const query = parseQueryString(location);
  const email = query.email ?
    query.email :
    ConfirmationResetMessages.emailPlaceholder();

  const styles = useStyles(themedStyles);
  return (
    <PublicPage>
      <BackButton/>
      <div className={styles.title}>
        {ConfirmationResetMessages.title()}
      </div>
      <div className={styles.body}>
        <div className={styles.bodyItem}>{ConfirmationResetMessages.requestedFor(email)}</div>
        <div className={styles.bodyItem}>{ConfirmationResetMessages.emailSent()}</div>
      </div>
      <div className={styles.buttonContainer}>
        <Link path={{ kind: BasePath.LOGIN }}>
          <ActiveButton>{ConfirmationResetMessages.submit()}</ActiveButton>
        </Link>
      </div>
    </PublicPage>
  );
};